import { useState, useEffect, useRef } from "react";
export default function HeroSection() {
  const ref = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section ref={ref} style={{
    backgroundImage: "linear-gradient(to right bottom, oklch(0.129 0.042 264.695) 0%, oklch(0.208 0.042 265.755) 50%, oklch(0.129 0.042 264.695) 100%)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(2, 8, 23)",
    fontFamily: '"DM Sans", sans-serif',
    alignItems: "center",
    display: "flex",
    position: "relative",
    overflow: "hidden",
    minHeight: "972px"
  }} className="w-full">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;700&family=DM+Sans:wght@400;600&display=swap');
        @keyframes fade-in-up {
          0% { opacity: 0; transform: translateY(24px); }
          100% { opacity: 1; transform: translateY(0px); }
        }
        .hero-gradient-text {
          background-image: linear-gradient(to right in oklab, rgb(37, 99, 235) 0%, rgb(6, 182, 212) 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .btn-primary-hero {
          background-image: linear-gradient(to right in oklab, rgb(37, 99, 235) 0%, rgb(6, 182, 212) 100%);
          transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .btn-primary-hero:hover {
          opacity: 0.9;
          transform: scale(1.03);
        }
        .btn-secondary-hero {
          transition: border-color 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .btn-secondary-hero:hover {
          background: rgba(255,255,255,0.05);
          transform: scale(1.03);
        }
      `}</style>

      <div className="absolute inset-0 w-full h-full" style={{
      backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.1) 1px, rgba(0, 0, 0, 0) 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, rgba(0, 0, 0, 0) 1px)",
      backgroundSize: "60px 60px, 60px 60px",
      backgroundPosition: "0% 0%, 0% 0%",
      backgroundRepeat: "repeat, repeat",
      backgroundBlendMode: "normal, normal",
      color: "rgb(2, 8, 23)",
      fontFamily: '"DM Sans", sans-serif',
      position: "absolute",
      opacity: 0.3,
      top: 0,
      left: 0
    }} />

      <div className="absolute bottom-0 left-0 w-full" style={{
      backgroundImage: "linear-gradient(to top in oklab, rgb(255, 255, 255) 0%, rgba(0, 0, 0, 0) 100%)",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      color: "rgb(2, 8, 23)",
      fontFamily: '"DM Sans", sans-serif',
      position: "absolute",
      height: "200px",
      bottom: 0,
      left: 0
    }} />

      <div className="page-container relative z-10 w-full">
        <div className="flex flex-col items-start" style={{
        paddingTop: "120px",
        paddingBottom: "100px"
      }}>

          <div className="flex items-center gap-2 mb-6" style={{
          border: "1px solid rgba(30, 58, 95, 0.8)",
          borderRadius: "9999px",
          padding: "8px 16px",
          background: "rgba(6, 13, 31, 0.7)"
        }}>
            <span style={{
            color: "#2563EB",
            display: "flex",
            alignItems: "center"
          }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"></path>
                <path d="M20 2v4"></path>
                <path d="M22 4h-4"></path>
                <circle cx="4" cy="20" r="2"></circle>
              </svg>
            </span>
            <span style={{
            color: "rgb(255,255,255)",
            fontFamily: '"DM Sans", sans-serif',
            fontSize: "13px",
            fontWeight: 400
          }}>
              Trusted by Local Businesses Across the Country
            </span>
          </div>

          <h1 style={{
          color: "rgb(255, 255, 255)",
          fontFamily: "Outfit, sans-serif",
          fontSize: "clamp(40px, 6vw, 72px)",
          fontWeight: "700",
          lineHeight: "1.08",
          letterSpacing: "-1.8px",
          border: "0px solid rgb(226, 232, 240)",
          animation: "0.6s ease-out 0s 1 normal none running fade-in-up",
          maxWidth: "700px",
          marginBottom: "24px"
        }}>
            Professional Websites<br />
            That{" "}
            <span className="hero-gradient-text">Turn Local Visitors</span>
            <br />
            <span className="hero-gradient-text">Into Customers</span>
          </h1>

          <p style={{
          color: "oklch(0.869 0.022 252.894)",
          fontFamily: '"DM Sans", sans-serif',
          fontSize: "20px",
          fontWeight: "400",
          lineHeight: "32.5px",
          border: "0px solid rgb(226, 232, 240)",
          animation: "0.6s ease-out 0s 1 normal none running fade-in-up",
          maxWidth: "500px",
          marginBottom: "32px"
        }}>
            We help local businesses grow with custom web design, local SEO, Google Business Profile optimization, and digital marketing strategies that generate real leads.
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-8">
            <a href="#" className="btn-primary-hero flex items-center gap-2 cursor-pointer" style={{
            color: "rgb(255, 255, 255)",
            fontFamily: '"DM Sans", sans-serif',
            fontSize: "16px",
            fontWeight: "600",
            lineHeight: "24px",
            borderRadius: "9999px",
            border: "0px solid rgb(226, 232, 240)",
            padding: "16px 32px",
            textDecoration: "none",
            alignItems: "center",
            gap: "8px"
          }}>
              Get a Free Consultation
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
            </a>

            <a href="#" className="btn-secondary-hero flex items-center gap-2 cursor-pointer" style={{
            color: "rgb(255, 255, 255)",
            fontFamily: '"DM Sans", sans-serif',
            fontSize: "16px",
            fontWeight: "600",
            lineHeight: "24px",
            borderRadius: "9999px",
            border: "2px solid oklch(0.446 0.043 257.281)",
            padding: "16px 32px",
            textDecoration: "none",
            alignItems: "center",
            gap: "8px",
            background: "transparent"
          }}>
              View Our Work
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="m9 18 6-6-6-6"></path>
              </svg>
            </a>
          </div>

          <div className="flex flex-wrap gap-x-6 gap-y-3">
            <div className="flex items-center gap-2">
              <span style={{
              color: "#64748B",
              display: "flex",
              alignItems: "center"
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <rect width="14" height="20" x="5" y="2" rx="2" ry="2"></rect>
                  <path d="M12 18h.01"></path>
                </svg>
              </span>
              <span style={{
              color: "#94A3B8",
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "14px",
              fontWeight: 400
            }}>Mobile Friendly</span>
            </div>

            <div className="flex items-center gap-2">
              <span style={{
              color: "#64748B",
              display: "flex",
              alignItems: "center"
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="m21 21-4.34-4.34"></path>
                  <circle cx="11" cy="11" r="8"></circle>
                </svg>
              </span>
              <span style={{
              color: "#94A3B8",
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "14px",
              fontWeight: 400
            }}>SEO Optimized</span>
            </div>

            <div className="flex items-center gap-2">
              <span style={{
              color: "#64748B",
              display: "flex",
              alignItems: "center"
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path>
                </svg>
              </span>
              <span style={{
              color: "#94A3B8",
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "14px",
              fontWeight: 400
            }}>Fast Loading</span>
            </div>

            <div className="flex items-center gap-2">
              <span style={{
              color: "#64748B",
              display: "flex",
              alignItems: "center"
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="m21 21-4.34-4.34"></path>
                  <circle cx="11" cy="11" r="8"></circle>
                </svg>
              </span>
              <span style={{
              color: "#94A3B8",
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "14px",
              fontWeight: 400
            }}>Lead Focused</span>
            </div>
          </div>

          <div className="flex items-center gap-2 mt-3">
            <span style={{
            color: "#64748B",
            display: "flex",
            alignItems: "center"
          }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
            </span>
            <span style={{
            color: "#94A3B8",
            fontFamily: '"DM Sans", sans-serif',
            fontSize: "14px",
            fontWeight: 400
          }}>Local Business Experts</span>
          </div>

        </div>
      </div>
    </section>;
}